<template>
  <div ref="component" class="stat-card-white">
    <div class="stat-header-white">
      <span>{{ chartLabel }}</span>
      <div v-if="!loader" class="d-flex align-items-center">
        <div v-if="!loader" class="expand-block px-2 mb-1 cursor-pointer position-relative">
          <img class="cursor-pointer" @click="showtable()" src="../../assets//img/table_view.png" alt="More block" />
          <div class="more-expand">
            <span>{{ $t("navigations.data overview") }}</span>
          </div>
        </div>
        <div v-if="!loader" class="expand-block px-2 mb-1 cursor-pointer" @click.prevent="expandBlock=true">
          <img src="../../assets//img/expand.png" alt="Expand block" />
        </div>
        <div class="text-center" v-on:clickout="showVisitPopup = false">
          <div
            class="position-relative cursor-pointer biggerfont ml-2"
            @click.prevent="showVisitPopup = !showVisitPopup"
          >
            <i class="fa fa-ellipsis-v"></i>
          </div>
          <div class="plan-side-popup" ref="excludeThis" v-if="showVisitPopup">
            <div @click.prevent="showVisitPopup = false,exporttoexcell()">
              Export to Excel
            </div>
            <div @click.prevent="exporttopdf()">
              Export to PDF
            </div>
            <div @click.prevent="exportDataPdf()">
              Export Data to PDF
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="stat-body-white" :class="{'bar-chart-wrapper flex-column':fromPage=='descriptiveStatistics','flex-column':loader==true}">
      <div v-if="enrolledornot && fromPage=='patientScreening' && !loader">
        <label class="mr-2">
          <input type="checkbox" v-model="aiPredictionTrue" @change="updateChart" /> Enrolled
        </label>
        <label>
          <input type="checkbox" v-model="aiPredictionFalse" @change="updateChart" /> Non-enrolled
        </label>
      </div>
      <div v-if="loader" class="loader"></div>
      <div ref="chartContainerWrapper" class="w-100" :class="{'d-flex flex-column':!loader && selectedGroups.length!=0}">
        
        <!-- Controls (dropdowns etc) -->
        <div v-if="!loader && requiredOptions" class="d-flex align-items-center float-left justify-content-between mb-2">
          <div class="d-flex">
            <label v-if="fromPage!='studySummary'" class="mb-0 mr-1" for="x-axis-select">{{ $t("navigations.attribute") }}:</label>
            <select v-if="fromPage!='studySummary'" class="graph-select mr-2" v-model="selectedXAxis" id="x-axis-select" @change="updateChart">
              <option v-for="option in xAxisOptions" :key="option" :value="option">{{ option }}</option>
            </select>
            <label v-if="fromPage!='studySummary'" class="mb-0 ml-2 mr-1" for="group-category-select">{{ $t("navigations.group category") }}:</label>
            <select v-if="fromPage!='studySummary'" class="graph-select" v-model="selectedGroupCategory" id="group-category-select" @change="updateChart">
              <option v-for="option in groupCategoryOptions" :key="option" :value="option">{{ option }}</option>
            </select>
          </div>
        </div>

        <!-- Legend (always on new row, wraps as needed) -->
        <div v-if="visibleLegendColorcodes.length && !loader" class="legend-wrap">
          <div v-for="colors in visibleLegendColorcodes" :key="colors.type" class="legend-item">
            <div class="legandbox" :style="`background-color: ${colors.color};`"></div>
            <span class="legend-label">{{ colors.type }}</span>
          </div>
        </div>

        <!-- Drill controls (below legend for clarity) -->
        <div v-if="!loader && selectedGroups.length!=0" class="d-flex flex-row-reverse gap-2 mb-2">
          <img class="cursor-pointer" src="../../assets/img/chart_cancel.png" @click.prevent="cancelselection()" alt="Cancel" />
          <img class="cursor-pointer" src="../../assets/img/chart_submit.png" @click.prevent="recreatechart()" alt="Submit" />
        </div>

        <!-- Chart & Axis label -->
        <svg ref="chartContainer" v-show="!loader"></svg>
        <div v-show="!loader" class="col-lg-12 text-center" style="margin-top: 8px;">
          {{ xAxisLabel }}
        </div>
      </div>
      <div ref="tooltip" class="tooltip"></div>
    </div>

    <enlargerpopup v-if="expandBlock==true" @closeModal="expandBlock=false,createChart()">
      <div class="stat-body-white d-flex flex-column">
        <div v-if="!loader && selectedGroups.length!=0" class="selectdrill d-flex flex-row-reverse gap-2 w-100">
          <img class="cursor-pointer" src="../../assets/img/chart_cancel.png" @click.prevent="cancelselection()" alt="Cancel" />
          <img class="cursor-pointer" src="../../assets/img/chart_submit.png" @click.prevent="recreatechart()" alt="Submit" />
        </div>
        <svg ref="popupChartContainer"></svg>
      </div>
    </enlargerpopup>
  </div>
</template>

<script>
import * as d3 from 'd3';
import axios from "axios";
import store from "../../store/index";
import enlargerpopup from "../AiCharts/popupfiles/enlarge_popup.vue"
import * as XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
import Study_summary from '@/components/study_summary/study_summary.vue';
export default {
  name: 'comparitiveBarChart',
  components: {
    enlargerpopup
  },
  props: {
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
    xAxisValue: {
      type: String,
      default: '',
    },
    showQueryLabel: {
      type: Boolean,
      default: false,
    },
    loader: {
      type: Boolean,
      default: false,
    },
    yAxisValue: {
      type: String,
      default: '',
    },
    groupCategoryValue: {
      type: String,
      default: '',
    },
    templateId: {
      type: String,
      default: ''
    },
    fromPage: {
      type: String,
      default: ""
    },
    enrolledornot: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 600,
    },
    height: {
      type: Number,
      default: 800,
    },
    chartLabel: {
      type: String,
      default: "Comparative Analysis"
    },
    xAxisLabel: {
      type: String,
      default: ""
    },
    yAxisLabel: {
      type: String,
      default: ""
    },
    requiredOptions: {
      type: Boolean,
      default: true
    },
    custcolors: {
      type: Array,
      default: () => [
        '#62B2FD', '#9BDFC4', '#ABF0FF', '#C1D1FF', '#FBD164', '#FDAD73'
      ],
    },
    colorcodes: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      showVisitPopup: false,
      idtoken: "",
      baseApi: process.env.VUE_APP_Service_URL,
      mappings: {},
      svg: null,
      selectedXAxis: this.xAxisValue || '',
      selectedYAxis: this.yAxisValue || '',
      selectedGroupCategory: this.groupCategoryValue || '',
      selectedStatistic: 'Count',
      xAxisOptions: [],
      yAxisOptions: [],
      groupCategoryOptions: [],
      aggregatedData: [],
      aiPredictionTrue: true,
      aiPredictionFalse: true,
      fixedGroupKeys: [],
      fixedSubCategories: [],
      expandBlock: false,
      barselectedarray: [],
      sortdata: [],
      filterkeyword: "",
      filterarray: [],
      selectedGroups: [],
      chartContainer: null,
      mouseX: 0,
      mouseY: 0
    };
  },
  watch: {
    data: {
      handler() {
        this.loadQuantitativeAttributes();
        this.cancelselection();
        this.createChart();
      },
      deep: true,
    },
    expandBlock(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this.createChart();
        });
      }
    }
  },
  computed: {
    visibleLegendCategories() {
      if (!this.aggregatedData || !this.aggregatedData.length) return [];
      const categories = new Set();
      this.aggregatedData.forEach(group => {
        group.values.forEach(val => {
          categories.add(val.category);
        });
      });
      return Array.from(categories);
    },
    visibleLegendColorcodes() {
      const visible = this.visibleLegendCategories;
      return visible.map((cat, i) => {
        const match = this.colorcodes.find(c => c.type === cat);
        return {
          type: cat,
          color: match ? match.color : this.custcolors[i % this.custcolors.length]
        }
      });
    }
  },
  beforeUnmount() {
    window.removeEventListener('mousemove', this.updateMousePosition);
  },
  async beforeMount() {
    this.idtoken = store.getters.getIdToken;
    if (this.fromPage == 'patientScreening') {
      await this.createmapping();
    }
    this.loadQuantitativeAttributes();
  },
  mounted() {

    this.chartContainer = this.expandBlock ? this.$refs.popupChartContainer : this.$refs.chartContainer;
    window.addEventListener('mousemove', this.updateMousePosition)
    this.tooltip = this.$refs.tooltip
    this.createChart();
    // Add resize observer to make SVG responsive
    this.resizeObserver = new ResizeObserver(() => this.createChart());
    this.resizeObserver.observe(this.chartContainer);

  },
  methods: {
    exportDataPdf() {
      this.$emit("exportDataPdf");
    },
    async exporttoexcell() {
      if (this.fromPage == 'studySummary') {
        const filteredData = this.data.map(item => {
          const newItem = { ...item }; // Create a shallow copy of the object
          delete newItem.FORMID; // Remove the unwanted key
          return newItem; // Return the new object without the unwanted key
        })
        const uniqueData = filteredData.reduce((acc, current) => {
          const uniqueKey = `${current.QUERYID}_${current.STUDYREF}`;
          if (current.QUERYID !== null && !acc.some(item => `${item.QUERYID}_${item.STUDYREF}` === uniqueKey)) {
            acc.push(current);
          }
          return acc;
        }, [])
        const worksheet = XLSX.utils.json_to_sheet(uniqueData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "Query Count.xlsx");

      }
      else {
        this.$emit("exporttoexcell");
      }


    },
    exporttopdf() {
      // Create a temporary container
      const excludeElement = this.$refs.excludeThis;
      excludeElement.style.display = 'none';
      const pdfContainer = document.createElement('div');

      const captureArea = this.$refs.component.cloneNode(true);
      // Append cloned elements to the container
      pdfContainer.appendChild(captureArea);

      // Optionally style the container for PDF formatting

      pdfContainer.style.width = '100%';

      pdfContainer.style.display = 'block';
      // Set the options for html2pdf
      const opt = {
        margin: 0,
        filename: `${this.fromPage == 'studySummary' ? `${this.$t('navigations.query count')}.pdf` : `Comparative Analysis.pdf`}`,
        image: { type: 'jpeg', quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: 'pt', format: 'a4', orientation: 'landscape' }
      };

      // Convert the temporary container to PDF
      html2pdf().set(opt).from(pdfContainer).save();
    },
    updateMousePosition(event) {
      if (this.$refs.component) {
        const rect = this.$refs.component.getBoundingClientRect();
        this.mouseX = event.clientX - rect.left;
        this.mouseY = event.clientY - rect.top;
      }
    },
    showtable() {
      if (this.fromPage == 'studySummary') {
        const uniqueData = this.data.reduce((acc, current) => {
          const uniqueKey = `${current.QUERYID}_${current.STUDYREF}`;
          if (current.QUERYID !== null && !acc.some(item => `${item.QUERYID}_${item.STUDYREF}` === uniqueKey)) {
            acc.push(current);
          }
          return acc;
        }, [])
        this.$emit("opendrillpopup", uniqueData.map(item => {

          const newItem = { ...item }; // Create a shallow copy of the object
          delete newItem.STUDYID; // Remove the unwanted key
          return newItem; // Return the new object without the unwanted key
        }), 'query')
      }
      else {
        this.$emit("opendrillpopup", this.data)
      }
    },
    async createmapping() {
      try {
        const response = await axios.get(
          `${this.baseApi}/forms/templatedesign/getpagesbyid?formId=${this.templateId}&version=1.0`,
          {
            headers: {
              Authorization: "Bearer " + this.idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data) {
          const pages = response.data.pages;
          pages.forEach(page => {
            page.field.forEach(field => {
              if (field.options && field.options.length > 0) {
                this.mappings[field.fieldName] = field.options.reduce((map, option) => {
                  map[option.codevalue] = option.optionname;
                  return map;
                }, {});
              }
            });
          });
        }
      } catch (error) {
        console.log("Error creating mappings", error);
      }
    },
    loadQuantitativeAttributes() {
      if (this.fromPage == 'patientScreening' || this.fromPage == 'patientRetention') {
        const sampleData = (this.data && this.data.length > 0 && this.data[0].features) ? this.data[0].features : {};

        const quantitativeAttributes = [];
        const qualitativeAttributes = [];
        const categories = [];

        Object.keys(sampleData).forEach(key => {
          const uniqueValues = new Set(this.data.map(item => item.features[key])).size;
          if (uniqueValues < 6) {
            qualitativeAttributes.push(key);
            categories.push(key);
          } else {
            quantitativeAttributes.push(key);
          }
        });
        this.xAxisOptions = qualitativeAttributes;
        this.selectedXAxis = this.xAxisValue || qualitativeAttributes[1] || '';
        this.yAxisOptions = quantitativeAttributes;
        this.selectedYAxis = this.yAxisValue || '';
        this.groupCategoryOptions = categories;
        this.selectedGroupCategory = this.groupCategoryValue || categories[0] || '';
        this.fixedGroupKeys = Array.from(new Set(this.data.map(d => this.getMappedValue(d.features[this.selectedXAxis], this.selectedXAxis))));
        this.fixedSubCategories = Array.from(new Set(this.data.map(d => this.getMappedValue(d.features[this.selectedGroupCategory], this.selectedGroupCategory))));
      }
      if (this.fromPage == 'descriptiveStatistics' || this.fromPage == 'demographicsScreen' || this.fromPage == 'labSummary' || this.fromPage == 'medicalHistory' || this.fromPage == 'labResult') {
        const sampleData = (this.data && this.data.length > 0) ? this.data[0] : {};

        const quantitativeAttributes = [];
        const qualitativeAttributes = [];
        const categories = [];

        Object.keys(sampleData).forEach(key => {
          if (key === '_id' || key === 'Participant ID' || key === 'STUDYID') {
            return;
          }

          const uniqueValues = new Set(this.data.map(item => item[key])).size;

          if (uniqueValues < 6) {
            qualitativeAttributes.push(key);
            categories.push(key);
          } else {
            quantitativeAttributes.push(key);
          }
        });
        this.xAxisOptions = qualitativeAttributes;
        this.selectedXAxis = this.xAxisValue || qualitativeAttributes[1] || '';
        this.yAxisOptions = quantitativeAttributes;
        this.selectedYAxis = this.yAxisValue || '';
        this.groupCategoryOptions = categories;
        this.selectedGroupCategory = this.groupCategoryValue || categories[0] || '';

      }
    },
    updateChart() {
      this.chartContainer = this.expandBlock ? this.$refs.popupChartContainer : this.$refs.chartContainer;
      // Clear existing chart
      d3.select(this.chartContainer).selectAll('*').remove();
      // Re-create the chart with new settings
      const groupandxaxis = {
        "xaxiskey": this.fromPage != 'studySummary' ? this.selectedXAxis : this.xAxisValue,
        "groupkey": this.fromPage != 'studySummary' ? this.selectedGroupCategory : this.groupCategoryValue,
      }
      this.$emit("setgroupkeys", groupandxaxis);
      this.cancelselection();
      this.createChart();
    },
    createChart() {
      // 1) pick the right container
      const containerRef = this.expandBlock
        ? this.$refs.popupChartContainer
        : this.$refs.chartContainer;

      // 2) margins + dimensions
      const margin = { top: 20, right: 60, bottom: 90, left: 60 };
      const totalWidth = this.width;
      const drawHeight = 300;
      const width = totalWidth - margin.left - margin.right;
      const height = drawHeight - margin.top - margin.bottom;

      // 3) aggregate & filter
      const aggregated = this.aggregateData(this.data);
      const dataReady = aggregated.filter(d => d.key && d.values.length);
      if (!dataReady.length) {
        console.error("No data to draw");
        return;
      }

      // 4) clear old chart
      d3.select(containerRef).selectAll("*").remove();

      // 5) setup SVG
      const svg = d3.select(containerRef)
        .attr("viewBox", `0 0 ${totalWidth} ${drawHeight}`)
        .attr("preserveAspectRatio", "xMinYMin meet")
        .style("width", "100%")
        .style("height", `${drawHeight}px`)
        .append("g")
        .attr("transform", `translate(${margin.left},${margin.top})`);

      // 6) scales
      const x0 = d3.scaleBand()
        .domain(dataReady.map(d => d.key))
        .range([0, width])
        .padding(0.1);

      const subCats = Array.from(
        new Set(aggregated.flatMap(d => d.values.map(v => v.category)))
      );

      const x1 = d3.scaleBand()
        .domain(subCats)
        .range([0, x0.bandwidth()])
        .padding(0.05);

      const yMax = d3.max(dataReady, d => d3.max(d.values, v => v.value)) || 0;
      const y = d3.scaleLinear()
        .domain([0, yMax * 1.1])
        .nice()
        .range([height, 0]);

      // default palette
      const colorScale = d3.scaleOrdinal()
        .domain(subCats)
        .range(this.custcolors);

      // ← your custom codes lookup
      const customColorMap = new Map(
        this.colorcodes.map(c => [c.type, c.color])
      );

      // 7) draw axes
      svg.append("g").call(d3.axisLeft(y));

      const xAxisG = svg.append("g")
        .attr("transform", `translate(0,${height})`)
        .call(d3.axisBottom(x0));

      xAxisG.selectAll("text")
        .text(t => t.length > 10 ? t.slice(0, 10) + "…" : t)
        .attr("transform", "rotate(-45)")
        .style("text-anchor", "end");

      // X label
      xAxisG.append("text")
        .attr("x", width / 2)
        .attr("y", margin.bottom - 20)
        .attr("text-anchor", "middle")
        .style("font-size", "12px")
        .text(this.xAxisLabel || this.selectedXAxis);

      // Y label
      svg.append("text")
        .attr("transform", "rotate(-90)")
        .attr("x", -height / 2)
        .attr("y", -margin.left + 20)
        .attr("text-anchor", "middle")
        .text(this.yAxisLabel);

      // 8) draw bars
      const groups = svg.selectAll(".group")
        .data(dataReady)
        .enter().append("g")
        .attr("transform", d => `translate(${x0(d.key)},0)`);

      groups.selectAll("rect")
        .data(d => d.values.map(v => ({ ...v, __key: d.key })))
        .enter().append("rect")
        .attr("x", d => x1(d.category))
        .attr("y", d => y(d.value))
        .attr("width", x1.bandwidth())
        .attr("height", d => height - y(d.value))
        // ← use custom color if present, else fallback to default palette
        .attr("fill", d =>
          customColorMap.get(d.category) || colorScale(d.category)
        )
        .attr("opacity", d =>
          this.selectedGroups.length
            ? (this.selectedGroups.includes(d.__key) ? 1 : 0.35)
            : 1
        )
        .style("cursor", "pointer")
        .on("click", (event, d) => this.toggleGroup(d.__key))
        .on("mouseover", (event, d) => {
          const g = d.__key || "Null";
          this.tooltip.style.opacity = 1;
          this.tooltip.innerHTML =
            `${this.xAxisLabel || this.selectedXAxis}: ${g}<br/>` +
            `Category: ${d.category}<br/>Value: ${d.value}`;
          this.tooltip.style.left = this.mouseX + "px";
          this.tooltip.style.top = this.mouseY + "px";
        })
        .on("mouseout", () => this.tooltip.style.opacity = 0);
    },


    /**
     * Toggle a whole group (x-axis key) in/out of drilldown.
     */
    toggleGroup(groupKey) {
      // build rawData for that group
      const filtered = this.data.filter(item => {
        const val = (this.fromPage === 'patientScreening' || this.fromPage === 'patientRetention')
          ? this.getMappedValue(item.features[this.selectedXAxis], this.selectedXAxis)
          : this.getMappedValue(item[this.selectedXAxis], this.selectedXAxis);
        return val === groupKey;
      });
      // reuse your drilldown logic
      this.drilldowndata(filtered, groupKey);
    },

    /**
     * Toggle a group key in/out of the current drill set
     */
    toggleBar(groupKey) {
      // build the raw-records array matching this groupKey
      const filtered = this.data.filter(item => {
        const val = (this.fromPage === 'patientScreening' || this.fromPage === 'patientRetention')
          ? this.getMappedValue(item.features[this.selectedXAxis], this.selectedXAxis)
          : this.getMappedValue(item[this.selectedXAxis], this.selectedXAxis);
        return val === groupKey;
      });

      // reuse your existing drilldowndata logic
      this.drilldowndata(filtered, groupKey);
    },
    drilldowndata(filteredData, filteredkeyword) {
      if (this.selectedGroups.includes(filteredkeyword)) {
        this.selectedGroups = this.selectedGroups.filter((k) => k !== filteredkeyword);
        let result = this.sortdata.filter(item => !filteredData.includes(item));
        this.sortdata = result;
        let filterarraydeleted = this.filterarray.filter(item => `(${filteredkeyword})` != item);
        this.filterarray = filterarraydeleted;
        this.filterkeyword = `${this.selectedXAxis}(${this.selectedGroups})`;
      } else {
        this.selectedGroups.push(filteredkeyword);
        this.filterarray.push(`(${filteredkeyword})`)
        this.filterkeyword = `${this.selectedXAxis}(${this.selectedGroups})`;
        this.sortdata = this.sortdata.concat(filteredData);
      }
      this.createChart();
    },
    async cancelselection() {
      this.selectedGroups = [];
      this.sortdata = [];
      this.createChart();
    },
    backtooriginal() {
      this.sortdata = [];
      this.selectedGroups = []; // Reset selection
    },
    recreatechart() {
      // this.$emit("opendrillpopup", this.sortdata);
      const dataToEmit = {
        sortedData: this.sortdata,
        filterkeyword: this.filterkeyword
      };
      this.$emit("drilldowncurrentchart", dataToEmit);
      const groupandxaxis = {
        "xaxiskey": this.selectedXAxis,
        "groupkey": this.selectedGroupCategory,
      }
      this.$emit("setgroupkeys", groupandxaxis);
    },
    // drilldowndata(key,fullArrayData){
    //   const dataToEmit = {
    //         sortedData: fullArrayData,
    //         filterkeyword: `${this.selectedXAxis}(${key})`
    //       };
    //       this.$emit("drilldowncurrentchart", dataToEmit);
    //       const groupandxaxis={
    //       "xaxiskey":this.selectedXAxis,
    //       "groupkey":this.selectedGroupCategory,
    //       }
    //       this.$emit("setgroupkeys", groupandxaxis);
    // },
    validateData(data) {
      return data.filter(
        (d) => {
          const aiPrediction = d.features.AIPrediction;
          if ((aiPrediction && this.aiPredictionTrue) || (!aiPrediction && this.aiPredictionFalse)) {
            return d.features[this.selectedXAxis] !== undefined && d.features[this.selectedGroupCategory] !== undefined;
          }
          return false;
        }
      );
    },
    aggregateData(data) {
      if (this.fromPage === 'patientScreening' || this.fromPage === 'patientRetention') {
        const validData = this.validateData(data);

        // Group by X-axis and Group Category, ensuring "null" is handled
        const nestedData = d3.group(
          validData,
          d => this.getMappedValue(d.features[this.selectedXAxis], this.selectedXAxis),
          d => this.getMappedValue(d.features[this.selectedGroupCategory], this.selectedGroupCategory)
        );

        this.aggregatedData = Array.from(nestedData, ([key, values]) => ({
          key,
          values: Array.from(values, ([category, records]) => ({
            category: category || "null", // Ensure null or empty strings are labeled as "null"
            value: this.selectedYAxis ? d3.sum(records, r => r.features[this.selectedYAxis]) : records.length
          }))
        }));
      }

      if (this.fromPage != 'patientScreenig' && this.fromPage != 'patientRetention') {
        const validData = this.data.filter(
          (d) => d[this.selectedXAxis] !== undefined && d[this.selectedGroupCategory] !== undefined
            && d[this.selectedGroupCategory] !== null && d[this.selectedGroupCategory] !== "null"
        );

        const nestedData = d3.group(
          validData,
          d => this.getMappedValue(d[this.selectedXAxis], this.selectedXAxis),
          d => this.getMappedValue(d[this.selectedGroupCategory], this.selectedGroupCategory)
        );

        this.aggregatedData = Array.from(nestedData, ([key, values]) => ({
          key: key || "null", // Ensure null or empty strings are labeled as "null"
          values: Array.from(values, ([category, records]) => ({
            category: category || "null", // Ensure null or empty strings are labeled as "null"
            value: this.selectedYAxis ? d3.sum(records, r => r[this.selectedYAxis]) : records.length
          }))
        }));
      }

      return this.aggregatedData;
    },
    getMappedValue(value, key) {
      // Check if the value is null or empty string
      if (value === null || value === "") {
        return "null"; // Return "null" to be displayed
      }

      // Return the mapped value if it exists, otherwise the original value
      return this.mappings[key] ? this.mappings[key][value] || value : value;
    },
  },
};
</script>

<style scoped>
@import "../AiCharts/charts.css";

.legend-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px 14px; /* less gap for dense legends */
  width: 100%;
  margin: 12px 0 16px 0; /* space above and below legend */
}

.legend-item {
  display: flex;
  align-items: center;
  min-width: 110px;
  margin-bottom: 2px;
  white-space: nowrap;
}

.legandbox {
  width: 15px;
  height: 15px;
  margin-right: 6px;
  flex-shrink: 0;
}

.legend-label {
  font-size: 13px;
  line-height: 1.2;
}


.bar-chart-wrapper {
  overflow-x: auto;
  width: 100%;
}

.bar-chart {
  position: relative;
}

.legend {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.legend-item {
  margin-right: 20px;
  display: flex;
  align-items: center;
}

.legend-color {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}

.legend-color.enrolled {
  background-color: darkblue;
}

.legend-color.non-enrolled {
  background-color: lightblue;
}

.controls {
  margin-bottom: 10px;
}

.controls label {
  margin-right: 5px;
}

.controls select {
  margin-right: 15px;
}

.gropbarwidth {
  height: 405px;
}

.loader {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.stat-body-white {
  overflow: visible;
}
</style>
